import PropTypes from 'prop-types'
import cn from 'classnames'

import slugify from 'scripts/utils/slugify'

import SVGS from './svgs'

const Icon = ({ icon, name }) => {
  const classes = cn(
    {
      [name]: name.length > 0
    }
  )

  return (
    <i className={classes}>
      { SVGS.header[slugify(icon)] }
    </i>
  )
}

Icon.prototype = {
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default Icon
